$('#recieved button').click(function(){
    $('#recieved').hide();
})